import { Routes } from "@angular/router";
import { PublicLayoutComponent } from "./layouts/public-layout/public-layout.component";
import { PrivateLayoutComponent } from "./layouts/private-layout/private-layout.component";
import { LoginComponent } from "./components/login/login.component";
import { ForgotPasswordComponent } from "./components/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { AuthGuard } from "./guards/auth.guard";
import { LoginGuard } from "./guards/login.guard";
import { ManageUsersComponent } from "./components/admin/manage-users/manage-users.component";
import { SupportComponent } from "./components/support/support.component";
import { SettingsComponent } from "./components/settings/settings.component";
import { UserProfileComponent } from "./components/user-profile/user-profile.component";
import { CustomerMasterComponent } from "./components/masters/customer-master/customer-master.component";
import {
  ManageCustomerComponent
} from "./components/masters/customer-master/manage-customer/manage-customer.component";
import { LocationMasterComponent } from "./components/masters/location-master/location-master.component";
import {
  ManageLocationComponent
} from "./components/masters/location-master/manage-location/manage-location.component";
import {
  CommodityCategoryMasterComponent
} from "./components/masters/commodity-category-master/commodity-category-master.component";
import {
  ManageCommodityCategoryComponent
} from "./components/masters/commodity-category-master/manage-commodity-category/manage-commodity-category.component";
import { CountyMasterComponent } from "./components/masters/county-master/county-master.component";
import {
  ManageCountryMasterComponent
} from "./components/masters/county-master/manage-country-master/manage-country-master.component";
import { BankMasterComponent } from "./components/masters/bank-master/bank-master.component";
import {
  ManageBankMasterComponent
} from "./components/masters/bank-master/manage-bank-master/manage-bank-master.component";
import { PackageMasterComponent } from "./components/masters/package-master/package-master.component";
import { ManagePackageComponent } from "./components/masters/package-master/manage-package/manage-package.component";
import { TrailerMasterComponent } from "./components/masters/trailer-master/trailer-master.component";
import {
  ManageTrailerMasterComponent
} from "./components/masters/trailer-master/manage-trailer-master/manage-trailer-master.component";
import { StateMasterComponent } from "./components/masters/state-master/state-master.component";
import {
  ManageStateMasterComponent
} from "./components/masters/state-master/manage-state-master/manage-state-master.component";
import { CityMasterComponent } from "./components/masters/city-master/city-master.component";
import { ManageCityComponent } from "./components/masters/city-master/manage-city/manage-city.component";
import { CommodityMasterComponent } from "./components/masters/commodity-master/commodity-master.component";
import {
  ManageCommodityComponent
} from "./components/masters/commodity-master/manage-commodity/manage-commodity.component";
import {
  VesselPortTrainDetailsMasterComponent
} from "./components/masters/vessel-port-train-details-master/vessel-port-train-details-master.component";
import {
  ManageVesselPortTrainDetailsComponent
} from "./components/masters/vessel-port-train-details-master/manage-vessel-port-train-details/manage-vessel-port-train-details.component";
import { VendorMasterComponent } from "./components/masters/vendor-master/vendor-master.component";
import { ManageVendorComponent } from "./components/masters/vendor-master/manage-vendor/manage-vendor.component";
import { ServiceMasterComponent } from "./components/masters/service-master/service-master.component";
import { EquipmentMasterComponent } from "./components/masters/equipment-master/equipment-master.component";
import { ManageServiceComponent } from "./components/masters/service-master/manage-service/manage-service.component";
import {
  ManageTransporterComponent
} from "./components/masters/transporter-master/manage-transporter/manage-transporter.component";
import { TransporterMasterComponent } from "./components/masters/transporter-master/transporter-master.component";
import { TrailerGateInComponent } from "./components/operations/gate-in/trailer/trailer-gate-in.component";
import { TruckGateInComponent } from "./components/operations/gate-in/truck/truck-gate-in.component";
import { ContainerGateInComponent } from "./components/operations/gate-in/container/container-gate-in.component";
import { ItemFilingComponent } from "./components/operations/item-filing/item-filing.component";
import {
  ManageItemFilingComponent
} from "./components/operations/item-filing/manage-item-filing/manage-item-filing.component";
import { HoldComponent } from "./components/operations/hold/manage-holds/hold.component";
import { ChipInputComponent } from "./components/common/chip-input/chip-input.component";
import { DynamicFormPocComponent } from "./components/dynamic-form-poc/dynamic-form-poc.component";
import { JobOrderComponent } from "./components/operations/job-orders/listing/job-orders.component";
import { TallyComponent } from "./components/operations/tally/tally.component";
import { ManageTallyComponent } from "./components/operations/tally/manage-tally/manage-tally.component";
import { ChargeComponent } from "./components/finance/charge/charge.component";
import { ManageChargeComponent } from "./components/finance/charge/manage-charge/manage-charge.component";
import {
  JobOrderRendererComponent
} from "./components/operations/job-orders/manage-job-orders/job-order-renderer/job-order-renderer.component";
import { TrailerGateOutComponent } from "./components/operations/gate-out/trailer/trailer-gate-out.component";
import { ContainerGateOutComponent } from "./components/operations/gate-out/container/container-gate-out.component";
import { TruckGateOutComponent } from "./components/operations/gate-out/truck/truck-gate-out.component";
import { ContainerListingComponent } from "./components/inventory/container/listing/container-listing.component";
import { VehicleListingComponent } from "./components/inventory/vehicle/listing/vehicle-listing.component";
import { ChargeGroupComponent } from "./components/finance/charge-group/charge-group.component";
import {
  ManageChargeGroupComponent
} from "./components/finance/charge-group/manage-charge-group/manage-charge-group.component";
import { CreateHoldComponent } from "./components/operations/hold/create-hold/create-hold.component";
import { ReleaseDocumentComponent } from "./components/operations/hold/release-document/release-document.component";
import { TariffComponent } from "./components/finance/tariff/tariff.component";
import {
  ManageTariffComponent
} from "./components/finance/tariff/manage-tariff/manage-tariff.component";
import { CustomerAgreementComponent } from "./components/finance/customer-agreement/customer-agreement.component";
import { InvoiceComponent } from "./components/finance/invoice/invoice.component";
import { ManageInvoicesComponent } from "./components/finance/invoice/manage-invoices/manage-invoices.component";
import {
  ManageIGMContainerComponent
} from "./components/operations/igm-desk/manage/manage-container/manage-igm-container";
import {
  ManageContainerInventoryComponent
} from "./components/inventory/container/manage-containers/manage-container-inventory";
import { ManageIgmComponent } from "./components/operations/igm-desk/manage-igm/manage-igm.component";
import { InvoiceDetailsComponent } from "./components/finance/invoice/invoice-details/invoice-details.component";
import { RecordPaymentComponent } from "./components/finance/record-payments/record-payment.component";
import { PaymentComponent } from "./components/finance/payments/payment.component";
import { CreditNoteComponent } from "./components/finance/credit-note/credit-note.component";
import {
  ManageCreditNoteComponent
} from "./components/finance/credit-note/manage-credit-note/manage-credit-note.component";
import {
  ManageUserRolesPermissionsComponent
} from "./components/admin/user-roles-permissions/manage-user-roles-permissions/manage-user-roles-permissions.component";
import { PermissionConstants } from "./constants/permission-constants";
import {
  ManageCustomerAgreementComponent
} from "./components/finance/customer-agreement/manage-customer-agreement/manage-customer-agreement.component";
import {
  ManageAgreementConfigurationComponent
} from "./components/finance/customer-agreement/manage-customer-agreement/manage-agreement-configuration/manage-agreement-configuration.component";
import { VehicleTypeMasterComponent } from "./components/masters/vehicle-master/vehicletype-master.component";
import { ShippingBillComponent } from "./components/shipping-bill/shipping-bill.component";
import {
  ManageShippingBillComponent
} from "./components/shipping-bill/manage-shipping-bill/manage-shipping-bill.component";
import { WarehouseMasterComponent } from "./components/masters/warehouse-master/warehouse-master.component";
import { WarehouseReservationComponent } from "./components/masters/warehouse-reservation/warehouse-reservation.component";

export const routes: Routes = [
  { path: "", redirectTo: "/login", pathMatch: "full" },
  {
    path: "login",
    component: PublicLayoutComponent,
    children: [{ path: "", component: LoginComponent }],
    canActivate: [LoginGuard]
  },
  {
    path: "forgot-password",
    component: PublicLayoutComponent,
    children: [{ path: "", component: ForgotPasswordComponent }],
    canActivate: [LoginGuard]
  },
  {
    path: "reset-password/:token",
    component: PublicLayoutComponent,
    children: [{ path: "", component: ResetPasswordComponent }],
    canActivate: [LoginGuard]
  },
  {
    path: "dashboard",
    component: PrivateLayoutComponent,
    children: [{ path: "", component: DashboardComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: "admin/manage-users",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.USERS.NAV] }
    },
    children: [
      { path: "", component: ManageUsersComponent },
      { path: "roles/add-new", component: ManageUserRolesPermissionsComponent, data: { showSideNav: false } },
      { path: "roles/edit/:roleId", component: ManageUserRolesPermissionsComponent, data: { showSideNav: false } },
      { path: "roles/view/:roleId", component: ManageUserRolesPermissionsComponent, data: { showSideNav: false } }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/customers",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.CUSTOMER_MASTER.NAV] }
    },
    children: [
      { path: "", component: CustomerMasterComponent },
      {
        path: "add-new",
        component: ManageCustomerComponent,
        data: { showSideNav: false }
      },
      {
        path: "edit/:customerId",
        component: ManageCustomerComponent,
        data: { showSideNav: false }
      },
      {
        path: "view/:customerId",
        component: ManageCustomerComponent,
        data: { showSideNav: false }
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/locations",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.LOCATION_MASTER.NAV] }
    },
    children: [
      { path: "", component: LocationMasterComponent },
      { path: "add-new", component: ManageLocationComponent, data: { showSideNav: false } },
      { path: "edit/:locationId", component: ManageLocationComponent, data: { showSideNav: false } },
      { path: "view/:locationId", component: ManageLocationComponent, data: { showSideNav: false } }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/cities",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.CITY_MASTER.NAV] }
    },
    children: [
      { path: "", component: CityMasterComponent },
      { path: "add-new", component: ManageCityComponent },
      { path: "edit/:cityId", component: ManageCityComponent },
      { path: "view/:cityId", component: ManageCityComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/commodities",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.COMMODITY_MASTER.NAV] }
    },
    children: [
      { path: "", component: CommodityMasterComponent },
      {
        path: "add-new", component: ManageCommodityComponent,
        data: { showSideNav: false }
      },
      {
        path: "edit/:commodityId",
        component: ManageCommodityComponent,
        data: { showSideNav: false }
      },
      {
        path: "view/:commodityId",
        component: ManageCommodityComponent,
        data: { showSideNav: false }
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/commodity-categories",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.COMMODITY_CATEGORY_MASTER.NAV] }
    },
    children: [
      { path: "", component: CommodityCategoryMasterComponent },
      { path: "add-new", component: ManageCommodityCategoryComponent },
      {
        path: "edit/:commodityCategoryId",
        component: ManageCommodityCategoryComponent
      },
      {
        path: "view/:commodityCategoryId",
        component: ManageCommodityCategoryComponent
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/countries",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.COUNTRY_MASTER.NAV] }
    },
    children: [
      { path: "", component: CountyMasterComponent },
      { path: "add-new", component: ManageCountryMasterComponent },
      { path: "edit/:countryId", component: ManageCountryMasterComponent },
      { path: "view/:countryId", component: ManageCountryMasterComponent }
    ],
    canActivate: [AuthGuard]
  },

  {
    path: "manage-finance/charges",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.CHARGE.NAV] }
    },
    children: [
      { path: "", component: ChargeComponent },
      {
        path: "add-new",
        component: ManageChargeComponent,
        data: { requiresPermission: { permissionIds: [PermissionConstants.CHARGE.CREATE] } }
      },
      {
        path: "edit/:chargeId",
        component: ManageChargeComponent,
        data: { requiresPermission: { permissionIds: [PermissionConstants.CHARGE.EDIT] } }
      },
      {
        path: "view/:chargeId",
        component: ManageChargeComponent,
        data: { requiresPermission: { permissionIds: [PermissionConstants.CHARGE.VIEW] } }
      },
      {
        path: ":chargeId/tariffs",
        children: [
          { path: "", component: TariffComponent, data: { showSideNav: false } },
          { path: "add-new", component: ManageTariffComponent, data: { showSideNav: false } },
          { path: "edit/:tariffId", component: ManageTariffComponent, data: { showSideNav: false } },
          { path: "view/:tariffId", component: ManageTariffComponent, data: { showSideNav: false } }
        ]
      }
    ],
    canActivate: [AuthGuard]
  },
  // {
  //   path: "manage-finance/:chargeId/tariffs",
  //   component: PrivateLayoutComponent,
  //   data: {
  //     requiresPermission: { permissionIds: [PermissionConstants.CHARGE.NAV] }
  //   },
  //   children: [
  //     { path: "", component: TariffComponent, data: { showSideNav: false } },
  //     { path: "add-new", component: ManageTariffComponent, data: { showSideNav: false } },
  //     { path: "edit/:tariffId", component: ManageTariffComponent, data: { showSideNav: false } },
  //     { path: "view/:tariffId", component: ManageTariffComponent, data: { showSideNav: false } }
  //   ],
  //   canActivate: [AuthGuard]
  // },
  {
    path: "manage-finance/charge-group",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.CHARGE_GROUP.NAV] }
    },
    children: [
      { path: "", component: ChargeGroupComponent },
      {
        path: "add-new",
        component: ManageChargeGroupComponent,
        data: {
          requiresPermission: { permissionIds: [PermissionConstants.CHARGE_GROUP.CREATE] }
        }
      },
      {
        path: "edit/:chargeGroupId",
        component: ManageChargeGroupComponent,
        data: {
          requiresPermission: { permissionIds: [PermissionConstants.CHARGE_GROUP.EDIT] }
        }
      },
      {
        path: "view/:chargeGroupId",
        component: ManageChargeGroupComponent,
        data: {
          requiresPermission: { permissionIds: [PermissionConstants.CHARGE_GROUP.VIEW] }
        }
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-finance/invoices",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.INVOICES.NAV] }
    },
    children: [
      { path: "", component: InvoiceComponent },
      { path: "add-new", component: ManageInvoicesComponent, data: { showSideNav: false } },
      { path: "view/:invoiceId", component: ManageInvoicesComponent, data: { showSideNav: false } },
      {
        path: "details",
        component: InvoiceDetailsComponent,
        data: { showSideNav: true, showContentWithoutPadding: true }
      },
      { path: "record-payments/:invoiceId", component: RecordPaymentComponent, data: { showSideNav: false } }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-finance/customer-agreement",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.CUSTOMER_AGREEMENT.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [
      { path: "", component: CustomerAgreementComponent },
      {
        path: "add-new",
        component: ManageCustomerAgreementComponent,
        data: {
          showSideNav: false,
          requiresPermission: { permissionIds: [PermissionConstants.CUSTOMER_AGREEMENT.CREATE] }
        }
      },
      {
        path: "edit/:agreementId",
        component: ManageCustomerAgreementComponent,
        data: {
          showSideNav: false,
          requiresPermission: { permissionIds: [PermissionConstants.CUSTOMER_AGREEMENT.EDIT] }
        }
      },
      {
        path: "view/:agreementId",
        component: ManageCustomerAgreementComponent,
        data: {
          showSideNav: false,
          requiresPermission: { permissionIds: [PermissionConstants.CUSTOMER_AGREEMENT.VIEW] }
        }
      },
      {
        path: ":agreementId/configurations",
        data: {
          requiresPermission: { permissionIds: [PermissionConstants.CUSTOMER_AGREEMENT.EDIT,PermissionConstants.CUSTOMER_AGREEMENT.CREATE] }
        },
        children: [
          { path: "", component: ManageCustomerAgreementComponent, data: { showSideNav: false } },
          { path: "add-new", component: ManageAgreementConfigurationComponent, data: { showSideNav: false } },
          {
            path: "edit/:configurationId",
            component: ManageAgreementConfigurationComponent,
            data: { showSideNav: false }
          },
          {
            path: "view/:configurationId",
            component: ManageAgreementConfigurationComponent,
            data: { showSideNav: false }
          },
          {
            path: "configure/:configurationId",
            component: ManageAgreementConfigurationComponent,
            data: { showSideNav: false }
          }
        ]
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-finance/receipts",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.RECEIPTS.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [
      { path: "", component: PaymentComponent },
      { path: "advance-payment", component: RecordPaymentComponent, data: { showSideNav: false } },
      { path: "record-payment", component: RecordPaymentComponent, data: { showSideNav: false } },
      { path: "view/:paymentId", component: RecordPaymentComponent, data: { showSideNav: false } }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-finance/credit-notes",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.CREDIT_NOTE.NAV] }
    },
    children: [
      { path: "", component: CreditNoteComponent },
      {
        path: "add-new",
        component: ManageCreditNoteComponent,
        data: { showSideNav: false, requiresPermission: { permissionIds: [PermissionConstants.CREDIT_NOTE.CREATE] } }
      },
      {
        path: "view/:creditNoteId",
        component: ManageCreditNoteComponent,
        data: { showSideNav: false, requiresPermission: { permissionIds: [PermissionConstants.CREDIT_NOTE.VIEW] } }
      }
    ],
    canActivate: [AuthGuard]
  },

  {
    path: "manage-masters/states",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.STATE_MASTER.NAV] }
    },
    children: [
      { path: "", component: StateMasterComponent },
      { path: "add-new", component: ManageStateMasterComponent },
      { path: "edit/:stateId", component: ManageStateMasterComponent },
      { path: "view/:stateId", component: ManageStateMasterComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/banks",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.BANK_MASTER.NAV] }
    },
    children: [
      { path: "", component: BankMasterComponent },
      { path: "add-new", component: ManageBankMasterComponent },
      { path: "edit/:bankId", component: ManageBankMasterComponent },
      { path: "view/:bankId", component: ManageBankMasterComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/packages",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.PACKAGE_MASTER.NAV] }
    },
    children: [
      { path: "", component: PackageMasterComponent },
      { path: "add-new", component: ManagePackageComponent },
      { path: "edit/:packageId", component: ManagePackageComponent },
      { path: "view/:packageId", component: ManagePackageComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/trailers",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.TRAILER_MASTER.NAV] }
    },
    children: [
      { path: "", component: TrailerMasterComponent },
      { path: "add-new", component: ManageTrailerMasterComponent },
      { path: "edit/:trailerId", component: ManageTrailerMasterComponent },
      { path: "view/:trailerId", component: ManageTrailerMasterComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/vessel-port-train-details",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.VESSEL_PORT_TRAIN_DETAIL_MASTER.NAV] }
    },
    children: [
      { path: "", component: VesselPortTrainDetailsMasterComponent },
      { path: "add-new", component: ManageVesselPortTrainDetailsComponent },
      {
        path: "edit/:vesselPortTrainDetailId",
        component: ManageVesselPortTrainDetailsComponent
      },
      {
        path: "view/:vesselPortTrainDetailId",
        component: ManageVesselPortTrainDetailsComponent
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/vendors",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.VENDOR_MASTER.NAV] }
    },
    children: [
      { path: "", component: VendorMasterComponent },
      { path: "add-new", component: ManageVendorComponent, data: { showSideNav: false } },
      { path: "edit/:vendorId", component: ManageVendorComponent, data: { showSideNav: false } },
      { path: "view/:vendorId", component: ManageVendorComponent, data: { showSideNav: false } }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/services",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.SERVICE_MASTER.NAV] }
    },
    children: [
      { path: "", component: ServiceMasterComponent },
      { path: "add-new", component: ManageServiceComponent, data: { showSideNav: false } },
      { path: "edit/:serviceId", component: ManageServiceComponent, data: { showSideNav: false } },
      { path: "view/:serviceId", component: ManageServiceComponent, data: { showSideNav: false } }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/equipments",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.EQUIPMENT_MASTER.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [
      { path: "", component: EquipmentMasterComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/warehouse-reservations",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.WAREHOUSE_RESERVATION.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [
      { path: "", component: WarehouseReservationComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/warehouses",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.WAREHOUSE_MASTER.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [
      { path: "", component: WarehouseMasterComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-masters/vehicle-types",
    data: {
      permissionConditionSet: { permissionIds: [PermissionConstants.MASTERS.VEHICLETYPE_MASTER.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [
      { path: "", component: VehicleTypeMasterComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-operations/trailer-gate-in",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.GATE_IN.TRAILER.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [{ path: "", component: TrailerGateInComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-operations/trailer-gate-out",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.GATE_OUT.TRAILER.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [{ path: "", component: TrailerGateOutComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-operations/truck-gate-in",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.GATE_IN.TRUCK.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [{ path: "", component: TruckGateInComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-operations/truck-gate-out",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.GATE_OUT.TRUCK.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [{ path: "", component: TruckGateOutComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-operations/container-gate-in",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.GATE_IN.CONTAINER.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [{ path: "", component: ContainerGateInComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-operations/container-gate-out",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.GATE_OUT.CONTAINER.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [{ path: "", component: ContainerGateOutComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-operations/igm-desk",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.IGM_DESK.NAV] }
    },
    children: [
      { path: "", component: ManageIgmComponent },
      { path: "edit/:container-id", component: ManageIGMContainerComponent, data: { showSideNav: false } },
      { path: "view/:container-id", component: ManageIGMContainerComponent, data: { showSideNav: false } }
    ],
    canActivate: []
  },
  {
    path: "manage-operations/shipping-bill",
    component: PrivateLayoutComponent,
    children: [
      { path: "", component: ShippingBillComponent },
      {path: "add-new", component: ManageShippingBillComponent, data: { showSideNav: false } },
      { path: "edit/:shippingBillId", component: ManageShippingBillComponent, data: { showSideNav: false } },
      { path: "view/:shippingBillId", component: ManageShippingBillComponent, data: { showSideNav: false } }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-operations/item-filing",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.ITEM_FILING.NAV] }
    },
    children: [
      { path: "add-new", component: ManageItemFilingComponent, data: { showSideNav: false } },
      { path: "edit/:item-filing-id", component: ManageItemFilingComponent, data: { showSideNav: false } },
      { path: "view/:item-filing-id", component: ManageItemFilingComponent, data: { showSideNav: false } },
      { path: "", component: ItemFilingComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-operations/import/tally",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.TALLY.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [
      { path: "", component: TallyComponent },
      { path: "add-new", component: ManageTallyComponent, data: { showSideNav: false } },
      { path: "edit/:tally-id", component: ManageTallyComponent, data: { showSideNav: false } },
      { path: "view/:tally-id", component: ManageTallyComponent, data: { showSideNav: false } }
    ],
    canActivate: []
  },
  {
    path: "manage-operations/import/job-orders",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.JOB_ORDER.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [
      { path: "", component: JobOrderComponent },
      { path: "create-new", component: JobOrderRendererComponent, data: { showSideNav: false } },
      { path: "edit/:job-order-id", component: JobOrderRendererComponent, data: { showSideNav: false } },
      { path: "view/:job-order-id", component: JobOrderRendererComponent, data: { showSideNav: false } }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-operations/hold",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.HOLD.NAV] }
    },
    children: [
      { path: "", component: HoldComponent },
      { path: "create-new", component: CreateHoldComponent, data: { showSideNav: false } },
      { path: "release-hold", component: ReleaseDocumentComponent, data: { showSideNav: false } }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-inventory/containers",
    component: PrivateLayoutComponent,
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.INVENTORY.CONTAINER.NAV] }
    },
    children: [
      { path: "", component: ContainerListingComponent },
      { path: "edit/:container-id", component: ManageContainerInventoryComponent },
      { path: "view/:container-id", component: ManageContainerInventoryComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "manage-inventory/vehicles",
    data: {
      requiresPermission: { permissionIds: [PermissionConstants.INVENTORY.VEHICLE.NAV] }
    },
    component: PrivateLayoutComponent,
    children: [
      { path: "", component: VehicleListingComponent },
      { path: "edit/:container-id", component: JobOrderRendererComponent },
      { path: "view/:container-id", component: JobOrderRendererComponent }
    ],
    canActivate: [AuthGuard]
  },
/*    {
      path: "test/side-panel",
      component: PrivateLayoutComponent,
      children: [{ path: "", component: ChipInputComponent }],
      canActivate: [AuthGuard]
    },
    {
      path: "test/payment",
      component: PrivateLayoutComponent,
      children: [{ path: "", component: RecordPaymentComponent }],
      canActivate: [AuthGuard]
    },*/
    {
      path: "test/dynamic-form",
      component: PrivateLayoutComponent,
      children: [{ path: "", component: DynamicFormPocComponent }],
      canActivate: [AuthGuard]
    },
  {
    path: "support",
    component: PrivateLayoutComponent,
    children: [{ path: "", component: SupportComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: "settings",
    component: PrivateLayoutComponent,
    children: [{ path: "", component: SettingsComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: "user-profile",
    component: PrivateLayoutComponent,
    children: [{ path: "", component: UserProfileComponent }],
    canActivate: [AuthGuard]
  },

  // Wildcard route for a 404 page
  { path: "**", component: PageNotFoundComponent }
];
